import { Component, ViewChild } from "@angular/core";
import { AdminService } from "../services/admin.service";
import { market_location } from '../models/market_location';
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm } from "@angular/forms";
import { OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';

@Component({
  selector: 'market_location-edit-component',
  templateUrl: './market_location.edit.component.html',
  styleUrls: ['./market_location.edit.component.css']
})
export class MarketLocationEditComponent implements OnInit {
  market_location: market_location = new market_location();

  editMode: boolean = false;

  @ViewChild('f') editForm: NgForm;
  constructor(
    private adminService: AdminService,
    private activatedRouter: ActivatedRoute,
    private routingRouter: Router,
    private _snackBar: MatSnackBar,
    private loggerService: LoggerService
  ) {
  }

  ngOnInit(): void {
    this.activatedRouter.url.subscribe(url => {
      if (url.length > 0) {
        if (url[0].path == 'new') {
          this.editMode = false;
        } else if (url[0].path == 'edit') {
          this.editMode = true;
          this.adminService.updatedMarketID.subscribe(data => {
            this.getUpdatedMarketData(data);
          });
        } else {
        }
      }
    }, err => {
      this.loggerService.log("MarketLocationEditComponent", err.message, Levels.error)
    })
  }

  insertData(newMarket: market_location) {
    this.adminService.insertMarket(newMarket).subscribe(data => {
      this.reloadComponent();
      this.openSnackBar("Market was successfully inserted", "Success");
      this.loggerService.log("MarketLocationEditComponent", 'market inserted successfully', Levels.info)

    }, err => {
      this.reloadComponent();
      this.openSnackBar("Error has occurred try again later", "Error");
      this.loggerService.log("MarketLocationEditComponent", err.message, Levels.error)

    });
  }

  updateData(updatedMarket: market_location) {
    this.adminService.updateMarket(updatedMarket).subscribe(data => {
      this.reloadComponent();
      this.openSnackBar("Market was updated", "Success");
      this.loggerService.log("MarketLocationEditComponent", 'market updated successfully', Levels.info)

    }, err => {
      this.reloadComponent();
      this.openSnackBar("Error has occurred try again later", "Error");
      this.loggerService.log("MarketLocationEditComponent", err.message, Levels.error)

    });
  }


  onSubmit() {
    if (this.editForm.valid) {
      if (this.editMode) {
        this.updateData(this.market_location);
      } else {
        this.insertData(this.market_location);
      }
    }
  }

  getUpdatedMarketData(updatedMarketID: number) {
    if (!updatedMarketID) {
      this.routingRouter.navigate(['marketlocation']);
      this.openSnackBar("Unauthorized", "Error");
      return;
    }
    this.adminService.getById(updatedMarketID).subscribe(data => {
      this.market_location = JSON.parse(JSON.stringify(data[0]));
    }, err => {
      this.loggerService.log("MarketLocationEditComponent", err.message, Levels.error)
    })
  }

  reloadComponent() {
    this.routingRouter.routeReuseStrategy.shouldReuseRoute = () => false;
    this.routingRouter.onSameUrlNavigation = 'reload';
    this.routingRouter.navigate(['/marketlocation']);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }
}
